import { useQuery } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";
import { arrayOrEmpty } from "utils";

import { AutomationCollection } from "../types/automation";

export const AUTOMATION_COLLECTIONS_QUERY_KEY = "automationCollections";

export default function useFetchAutomationCollections() {
  return useQuery<AutomationCollection[]>(
    [AUTOMATION_COLLECTIONS_QUERY_KEY],
    async () => {
      const response = await axios.get<AutomationCollection[]>(
        `${AUTOMATION_SERVICE_ADDRESS}/automation`
      );
      return arrayOrEmpty(response.data);
    }
  );
}
